// bao migrate skip
import Bao from "./../../services/bao-service";
import * as ko from "knockout";
class SummaryReportRoleTabDialog {
    SummaryReportId: KnockoutObservable<string>;
    RoleName: KnockoutObservable<string>;
    Parent: any;
    RoleId: KnockoutObservable<string>;
    constructor($data: {
        SummaryReportName;
        Parent: any;
    }, $dialog) {
        $.extend(this, $data);
        this.SummaryReportId.subscribe((newval) => {
            this.Parent.TabPage.IsLoading(true);
        });
    }
    init() {
    }
}
export default SummaryReportRoleTabDialog;